import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: `flex ${_ctx.borderTop ? 'flex-col-reverse' : 'flex-col'}`
  }, [
    _createVNode("div", {
      class: ["header flex w-full border-gray-400", `${_ctx.borderTop ? 'border-t' : 'border-b'}`]
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["relative cursor-pointer py-2 px-6 rounded-tr rounded-tl text-gray-700 hover:text-navy-blue-700", {
          ' text-navy-blue-700': _ctx.currentTab === index + 1,
        }],
          key: index,
          onClick: $event => (_ctx.currentTab = index + 1)
        }, [
          _createVNode("div", null, [
            _renderSlot(_ctx.$slots, "item", { item: item }),
            (!_ctx.$slots.item)
              ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(item.header), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, {
            name: `slide-fade-${_ctx.currentTab > _ctx.prevTab ? 'right' : 'left'}`
          }, {
            default: _withCtx(() => [
              (_ctx.currentTab === index + 1)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: [`${_ctx.borderTop ? 'top-0' : 'bottom-0'}`, "w-full absolute left-0 border-b-2 border-navy-blue-700 text-navy-blue-700"]
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["name"])
        ], 10, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2),
    _createVNode(_Transition, { name: " fade" }, {
      default: _withCtx(() => [
        (_ctx.items[_ctx.currentTab - 1].body)
          ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.items[_ctx.currentTab - 1].body), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}